import { render, staticRenderFns } from "./CalculationDetailsTable.vue?vue&type=template&id=78c9d38b&"
import script from "./CalculationDetailsTable.vue?vue&type=script&lang=js&"
export * from "./CalculationDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports